module.exports = __webpack_public_path__ + "img/speakericon.b37e564a.png";